// Shared by Expo and the server, like content/workGuideCatalog. Keep this module
// free of browser, React, filesystem, and image-rendering dependencies.
const cardTemplates = require('../content/socialShareCards.json');
const { MODEL_TOTAL } = require('../constants/modelInventoryCounts.generated.json');
const cards = Object.fromEntries(Object.entries(cardTemplates).map(([route, copy]) => [route,
  Object.fromEntries(Object.entries(copy).map(([key, value]) => [key,
    typeof value === 'string' ? value.replace(/\{\{MODEL_TOTAL\}\}/g, String(MODEL_TOTAL)) : value,
  ])),
]));
const ORIGIN = 'https://gab.ai';
const ASSET_ROOT = '/social-cards/2026-09';

function normalizeSharePath(canonical) {
  if (typeof canonical !== 'string' || !canonical.trim()) return '/';
  try {
    const url = new URL(canonical.trim(), ORIGIN);
    const pathname = url.pathname.replace(/\/+$/, '') || '/';
    return pathname === '/docs/index' ? '/docs' : pathname;
  } catch {
    return '/';
  }
}

function getPageShareCard(canonical) {
  const route = normalizeSharePath(canonical);
  if (!Object.prototype.hasOwnProperty.call(cards, route)) return null;
  const copy = cards[route];
  const imagePath = copy.imagePath || (route === '/'
    ? '/social-card-minimal-2026-09.png'
    : `${ASSET_ROOT}${route}.png`);
  return {
    ...copy,
    route,
    imagePath,
    image: `${ORIGIN}${imagePath}`,
    alt: `Gab AI — ${copy.headline.replace(/\n/g, ' ')} ${copy.subtitle} ${copy.footer}`,
  };
}

function getFallbackShareCard(canonical) {
  let route = normalizeSharePath(canonical);
  // Catalog detail pages retain their own image, or use their section's card.
  if (route.startsWith('/start/')) route = '/topics';
  if (route.startsWith('/m/')) route = '/models';
  while (route !== '/') {
    const card = getPageShareCard(route);
    if (card) return card;
    route = route.slice(0, route.lastIndexOf('/')) || '/';
  }
  return getPageShareCard('/');
}

function resolveShareImage(canonical, image) {
  return image || getFallbackShareCard(canonical).image;
}

// Video is opt-in per exact page. Never inherit it through the image fallback:
// a missing canonical or an unknown/detail page must not advertise the home film.
function getPageShareVideo(canonical) {
  if (typeof canonical !== 'string' || !canonical.trim()) return null;
  const video = getPageShareCard(canonical)?.video;
  if (!video?.path) return null;
  return { url: `${ORIGIN}${video.path}`, type: video.type, width: video.width, height: video.height };
}

module.exports = { cards, normalizeSharePath, getPageShareCard, getFallbackShareCard, resolveShareImage, getPageShareVideo };
